/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ObservableImage.ts
 * Project: mle-client-n
 * Committed last: 2022/2/12 @ 1734
 * ---
 * Description:
 */


import { ObservableSetterOptions, ObservableShape }     from './ObservableShape';
import Pamela
                                                        from '@revodigital/pamela';
import { Editor }                                       from './Editor';
import { action, computed, makeObservable, observable } from 'mobx';
import {
  Size2D, sizeOf
}                                                       from '@revodigital/pamela/lib/common/Size2D';

export class ObservableImage extends ObservableShape<Pamela.Image> {
  @observable
  private _src: string;
  @observable
  private _assetId: number;
  @observable
  private _cropX: number;
  @observable
  private _cropY: number;
  @observable
  private _cropWidth: number;
  @observable
  private _cropHeight: number;
  @observable
  private readonly _originalSize: Size2D;

  constructor(shape: Pamela.Image, editor: Editor) {
    super(shape, editor);
    this._src = shape.src();
    this._originalSize = shape.getOriginalSize() as Size2D || sizeOf(0, 0);
    this._cropHeight = shape.cropHeight();
    this._cropWidth = shape.cropWidth();
    this._cropX = shape.cropX();
    this._cropY = shape.cropY();
    this._assetId = shape.assetId();
    makeObservable(this);
  }

  @computed
  public get src() {
    return this._src;
  }

  @computed
  public get assetId() {
    return this._assetId;
  }

  @computed
  public get originalSize() {
    return this._originalSize;
  }

  @computed
  public get cropX() {
    return this._cropX;
  }

  @computed
  public get cropY() {
    return this._cropY;
  }

  @computed
  public get cropWidth() {
    return this._cropWidth;
  }

  @computed
  public get cropHeight() {
    return this._cropHeight;
  }

  @action
  public setCropX(value: number, options: ObservableSetterOptions) {
    this._cropX = value;

    if (options.applyToPamelaShape) this.pamelaShape__nonObservable.cropX(value);
  }

  @action
  public resetCrop(options: ObservableSetterOptions) {
    this.setCropY(0, options);
    this.setCropX(0, options);
    this.setCropHeight(0, options);
    this.setCropWidth(0, options);
  }

  @action
  public setCropY(value: number, options: ObservableSetterOptions) {
    this._cropY = value;

    if (options.applyToPamelaShape) this.pamelaShape__nonObservable.cropY(value);
  }

  @action
  public setCropWidth(value: number, options: ObservableSetterOptions) {
    this._cropWidth = value;

    if (options.applyToPamelaShape) this.pamelaShape__nonObservable.cropWidth(
      value);
  }

  @action
  public setCropHeight(value: number, options: ObservableSetterOptions) {
    this._cropHeight = value;

    if (options.applyToPamelaShape) this.pamelaShape__nonObservable.cropHeight(
      value);
  }
}